export default {
  transitionClass: 'is-transitioning',
}
